import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import store from '../../app/store';
import { AuthModel } from './models/user-model.interface';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export interface ITokens {
  access: {
    expires: string;
    token: string;
  };
  refresh: {
    expires: string;
    token: string;
  };
}

const initialState: IAuthState = {
  user: undefined,
  tokens: undefined,
  isAuthorized: false,
  isJoyride: true,
  impersonator: null,
  originalAuth: null,
};

export interface IImpersonator {
  id: number;
  name: string;
  surname: string;
  email: string;
}

export interface IOriginalAuth {
  user: AuthModel | null | any;
  tokens: ITokens | null;
}

export interface IAuthState {
  user?: AuthModel | null | any;
  tokens?: ITokens | null;
  isAuthorized: boolean;
  isJoyride: boolean;
  impersonator?: IImpersonator | null;
  originalAuth?: IOriginalAuth | null;
}
export const companyList = createAsyncThunk('company/list', async () => {
  const user_id = store.getState()?.auth?.user?.id;
  const company_id = store.getState()?.auth?.user?.company?.id;
  var params = { user_id, company_id };
  const res = await axios.get<any>(`${REACT_APP_API_URL}/company/list`, { params });
  return res.data;
});

export const companyChange = createAsyncThunk('company/change', async (body: any) => {
  const res = await axios.post<any>(`${REACT_APP_API_URL}/auth/change/branch`, body);
  return res.data;
});

export const userSlice = createSlice({
  name: 'EDuser',
  initialState,
  reducers: {
    _login: (state, action: PayloadAction<IAuthState>) => {
      state.tokens = action.payload.tokens;
      state.user = action.payload.user;
      state.isAuthorized = true;
    },
    _logOut: (state) => {
      state.user = null;
      state.tokens = null;
      state.isAuthorized = false;
      state.impersonator = null;
      state.originalAuth = null;
    },
    _setStamp: (state, action) => {
      state.user.company.stamp = action.payload;
    },
    _changeCompany: (state, action) => {
      state.user.company = action.payload;
      state.user.company_id = action.payload.id;
    },
    _setJoyride: (state) => {
      state.isJoyride = false;
    },
    _impersonate: (state, action: PayloadAction<{ user: any; tokens: ITokens; impersonator: IImpersonator }>) => {
      // Save current admin auth data before switching
      state.originalAuth = {
        user: state.user,
        tokens: state.tokens as ITokens | null,
      };
      state.impersonator = action.payload.impersonator;
      state.user = action.payload.user;
      state.tokens = action.payload.tokens;
      state.isAuthorized = true;
    },
    _stopImpersonate: (state) => {
      if (state.originalAuth) {
        state.user = state.originalAuth.user;
        state.tokens = state.originalAuth.tokens;
      }
      state.impersonator = null;
      state.originalAuth = null;
      state.isAuthorized = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(companyList.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(companyChange.fulfilled, (state, action) => {
      state.tokens = action.payload.tokens;
      state.user = action.payload.user;
      state.isAuthorized = true;
      setTimeout(() => {
        window.location.reload();
      }, 200);
    });
  },
});

export const { _login, _logOut, _setStamp, _changeCompany, _setJoyride, _impersonate, _stopImpersonate } = userSlice.actions;
export default userSlice.reducer;
